import { PermittedFileType } from '../declarations';

export const MIME_TYPES = {
  pdf: 'application/pdf' as PermittedFileType,
};
